module.exports = __webpack_public_path__ + "img/photo_220310571_1.a53dfe42.png";